export { MorphemeDetailsTileStatsSection } from "#morpheme-details-tile-stats-section";
export {
  getMorphemeDetailsTileStatsSectionGate,
  type MorphemeDetailsTileStatsSectionGate,
} from "#get-morpheme-details-tile-stats-section-gate";
